import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {Link} from '../../../common/components';
import {ContentFilterTable} from '../tables/ContentFilterTable';

export const ContentFilterSection = () => {
    return (
        <div id="contentfilter">
            <h1>Content Filtering</h1>
            <section className="narrow">
                <p>
            We offer flexible content filters that enable you to offer the type
            of content that is the best fit for your users. Our filters are
            designed to map to the MPAA though important to note we do not
            surface the type of nudity that may be found in R rated films.
            If you become aware of such content, please inform us immediately
            by contacting <Link
                        to="mailto:support@tenor.com">support@tenor.com</Link>.
                </p>
                <p>Note: this feature was previously called SafeSearch.</p>

                <h4>ContentFilter options:</h4>
                <ol className="numbered-list indent-align">
                    <li>
                        <b>high</b> - G
                    </li>
                    <li>
                        <b>medium</b> - G and PG
                    </li>
                    <li>
                        <b>low</b> - G, PG, and PG-13
                    </li>
                    <li>
                        <b>off</b> - G, PG, PG-13, and R (no nudity)
                    </li>
                </ol>
            </section>

            <section>
                <ContentFilterTable title="VIOLENCE" content={[
                    {'description-title': 'Mild cartoon violence', 'rating': ['pg', 'pg13', 'r']},
                    {'description-title': 'Humorous violence & Comic Mischief', 'rating': ['pg', 'pg13', 'r']},
                    {'description-title': 'Realistic Violence', 'rating': ['pg13', 'r']},
                    {'description-title': 'Graphic Violence', 'rating': ['r']},
                ]}/>
            </section>

            <section>
                <ContentFilterTable title="PROFANITY" content={[
                    {'description-title': 'Mild Profanity', 'rating': ['pg', 'pg13', 'r']},
                    {'description-title': 'Censored Profanity', 'rating': ['pg', 'pg13', 'r']},
                    {'description-title': 'Strong Profanity', 'rating': ['pg13', 'r']},
                ]}/>
            </section>

            <section>
                <ContentFilterTable title="SEXUAL CONTENT" content={[
                    {'description-title': 'Partial/non-detailed nudity (includes cartoon)', 'rating': ['pg', 'pg13', 'r']},
                    {'description-title': 'Animated depiction of genitals', 'rating': ['pg13', 'r']},
                    {'description-title': 'Non-sexual kisses', 'rating': ['pg', 'pg13', 'r']},
                    {'description-title': 'Mention of sex, genitals, etc', 'rating': ['pg13', 'r']},
                    {'description-title': 'Suggestive sexual content', 'rating': ['pg13', 'r']},
                    {'description-title': 'Strong sexual content', 'rating': ['r']},
                ]}/>
            </section>

            <section>
                <ContentFilterTable title="SUBSTANCE USE" content={[
                    {'description-title': 'Implied Alcohol or Tobacco Use', 'rating': ['pg', 'pg13', 'r']},
                    {'description-title': 'Depicts Alcohol or Tobacco Use', 'rating': ['pg13', 'r']},
                    {'description-title': 'Implied Drug Use', 'rating': ['pg13', 'r']},
                    {'description-title': 'Depicts Drug Use', 'rating': ['r']},
                ]}/>
            </section>

            <section>
                <ContentFilterTable title="MISC" content={[
                    {'description-title': 'Depicts Gambling', 'rating': ['pg13', 'r']},
                    {'description-title': 'Inflammatory Content', 'rating': ['r']},
                    {'description-title': 'Mild Horror', 'rating': ['pg', 'pg13', 'r']},
                    {'description-title': 'Intense Horror', 'rating': ['pg13', 'r']},
                    {'description-title': 'Depicts firearms or weapons', 'rating': ['pg', 'pg13', 'r']},
                    {'description-title': 'Firearms or weapons in use', 'rating': ['pg13', 'r']},
                    {'description-title': 'Firearms or weapons in use with a serious intent to harm', 'rating': ['r']},
                ]}/>
            </section>
        </div>
    );
};
